import { SITE } from "./site";

// Metadata builders (template §7). Every route owns its metadata; none inherits the site default by
// accident.
//
// This portal is Mode B and entirely behind a login, so its pages are deliberately NOINDEX: an
// account page has no business in a search index, and a crawler cannot reach it anyway. The builder
// still exists and is called per route, because template §0.2 is a structural habit — when public
// marketing routes are added later they get real metadata through this same path.
export function buildMeta({ title, description, path = "/", noindex = true }) {
  return {
    title: title ? `${title} · ${SITE.shortName}` : SITE.name,
    description: description || SITE.description,
    canonical: SITE.url ? `${SITE.url}${path}` : null,
    robots: noindex ? "noindex, nofollow" : "index, follow",
  };
}
